module.exports = __webpack_public_path__ + "img/1.07b0cc3e.jpg";